import { Lifestyle } from "@/clients/models/Lifestyle";
import { LifestyleService } from "@/clients/services/LifestyleService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useUpdateLifestyle = () => {
  const mutation = useMutation({
    mutationKey: [QueryKeys.LIFESTYLE],
    mutationFn: async (data: Lifestyle) => {
      const user = guardGetUserFromLocalStorage();
      await LifestyleService.updateLifestyleApiV1LifestylePut(user.id, data);
    },
  });

  return {
    updateLifestyle: mutation.mutate,
    isUpdating: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
